/**
 * Returns a consistent color for a given ops identifier.
 * Known ops have a fixed brand color; unknown ops get a deterministic color
 * from a palette based on a hash of the ops name.
 */

const OPS_FIXED: Record<string, string> = {
  rayo:        '#EF4444', // red-500
  rayosp:      '#F97316', // orange-500
  rayogyn:     '#F59E0B', // amber-500
  rayobsb:     '#EAB308', // yellow-500
  muve:        '#8B5CF6', // violet-500
  entrego:     '#EC4899', // pink-500
  indrive:     '#3B82F6', // blue-500
  bee:         '#D97706', // amber-600
  logus:       '#10B981', // emerald-500
  agility:     '#6366F1', // indigo-500
  inovabc:     '#14B8A6', // teal-500
  inovasp:     '#06B6D4', // cyan-500
  ppprime:     '#84CC16', // lime-500
  ppprimebru:  '#65A30D', // lime-600
  rondolog:    '#0EA5E9', // sky-500
  xpto:        '#A855F7', // purple-500
  realogtji:   '#E11D48', // rose-600
  gestor:      '#1D4ED8', // blue-700
};

const OPS_PALETTE = [
  '#EF4444', '#F97316', '#EAB308', '#22C55E',
  '#14B8A6', '#3B82F6', '#6366F1', '#8B5CF6',
  '#EC4899', '#F43F5E', '#0EA5E9', '#84CC16',
];

function hashOps(ops: string): number {
  let h = 0;
  for (let i = 0; i < ops.length; i++) {
    h = (Math.imul(31, h) + ops.charCodeAt(i)) | 0;
  }
  return Math.abs(h);
}

export function getOpsColor(ops: string): string {
  return OPS_FIXED[ops] ?? OPS_PALETTE[hashOps(ops) % OPS_PALETTE.length];
}
